import { DatePipe } from '@angular/common';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { of } from 'rxjs';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { LocMatCtlD } from 'src/app/shared/models/LocMatCtlD';
import { LocMatCtlM } from 'src/app/shared/models/LocMatCtlM';
import { Constants } from 'src/app/shared/vo/Constants';
import { StatusType } from 'src/app/shared/vo/StatusType';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';

@Component({
  selector: 'app-loc-mat-ctl-dtl',
  templateUrl: './loc-mat-ctl-dtl.component.html',
  styleUrls: ['./loc-mat-ctl-dtl.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class LocMatCtlDtlComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** COMPONENT */
  languages: any[];
  periods: any[];
  currencies: any[];
  guides: CategoryLan[];
  stores: any[];
  materials: any[];
  materialsTmp: any[];
  materialsTotal: any[];
  workshops: any[];
  isButtonClicked: boolean = false;

  /** DATAPARENT */
  dataParent: any = {};

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = null;

  /** DIALOG */
  displayModalApprove: boolean = false;

  /** COMPONENT OVERLAY */
  blocked: boolean = true;
  editingRow: any = null;
  isOnlyArticles: boolean;

  /** ENDPOINTS */
  endPointLanguageByStoreId = "getListSpkLangByStoreId";
  endPointGetReqMat = "getGuideReqMat";
  endPointGetGuideSelectedPriceLst = "getGuideSelectedPriceLst";
  endPointFindPeriodGuideDescrip = "findPeriodGuideDescrip";
  endPointSearchCategory = "searchCategory";
  endPointGetPublicPackPriceLst = "getPublicPackLstPrice";

  // Original
  endPointGetLocMatCtlM = "getLocMatCtlM";
  endPointUpdtaCreateLocMatCltM = "updateCreateLocMatCtlM";
  endPointGetLocMatCtlD = "getLocMatCtlD";
  endPointUpdtaCreateLocMatCltD = "updateCreateLocMatCtlD";

  endPointRemoveRecordLocmatcM: string = "removeRecordLocmatcltM";
  endPointApproveLocMatCtlInventory: string = "approveLocMatCtlInventory";
  endPointGetValidPeriods = "getValidPeriods";
  endPointGetStoreById = "getStoreById";
  endPointGetGuideById = "getGuideById";
  endPointCheckOpenOrders = "getCheckOpenOrders";

  // Rework
  endPointGetLocMatCtlMById = "getLocmatctlmById";
  endPointCrudLocMatCtlM = "crudLocMatCtl"
  endPointUpdateLocMatCtlM = "updateLocmatctlm";

  /**
  * This constructor function initializes various services and variables used in the component, and also
  * checks for authentication based on the token and device parameters passed in the URL.
  * @param {MessageService} messageService - This parameter is of type MessageService and is used for
  * displaying messages to the user. It is likely used to show success or error messages during certain
  * operations.
  * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
  * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
  * confirmation before performing certain actions.
  * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
  * making API requests and handling responses.
  * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
  * which is used to access the current route's information. It provides access to the route's
  * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
  * used to subscribe to the
  * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
  * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
  * the current user's information.
  * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
  * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
  * downloading files.
  * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
  * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
  * on data in the application.
  * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
  * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
  */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private urlBuilderService: UrlBuilderService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private tovUtilsService: TovpilUtilsService,
    private userPreferencesService: UserPreferencesService,
    private router: Router,
    private filesService: TovpilFilesService,
    private translationService: TovpilLanguageService,
  ) {

    this.route.queryParams.subscribe(params => {
      this.dataParent.guideId = params.guideId === 'null' ? null : params.guideId;
      this.dataParent.docType = params.docType === 'null' ? null : params.docType;
      this.dataParent.year = params.year === 'null' ? null : params.year;
      this.dataParent.wrksId = params.wrksId === 'null' ? null : params.wrksId;
      this.dataParent.language = params.language === 'null' ? null : params.language;

      this.dataParent.sequence = params.sequence === 'null' ? null : params.sequence;
      this.dataParent.isOnlyArticles = params.isOnlyArticles === 'true';


      this.dataParent.amount = params.amount === 'null' ? null : params.amount;
      this.dataParent.date = params.date === 'null' ? null : params.date;
      this.dataParent.package = params.package === 'null' ? null : params.package;
      this.dataParent.status = params.status === 'null' ? null : params.status;
      this.dataParent.levelId = params.levelId === 'null' ? null : params.levelId;


      this.dataParent.type = params.type === 'null' ? null : params.type;
    });
    this.createDataForm();
    this.initConfigs();


    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

  /**
    * The function initializes form groups for configuration and data, and updates the configuration form
    * with query parameters from the route.
    */
  async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    // // console.debug("CX3 LGD - USER PREFERENCES: " + JSON.stringify(this.globalUserPreferences, null, 2));
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedLanguage: new FormControl({ value: null, disabled: true }),
      selectedPeriod: new FormControl({ value: null, disabled: true }),
      selectedGuide: new FormControl({ value: null, disabled: true }),
      selectedCoordination: new FormControl({ value: null, disabled: true }),
      selectedCoordinationLevelId: new FormControl({ value: null, disabled: true }),

      /** COMPONENTE ELEMENTS */
      selectedComponentType: new FormControl({ value: null, disabled: true }),

      /** SETTING POST INIT */
      selectedworksId: new FormControl({ value: null, disabled: true }),
      selectedPrice: new FormControl({ value: null, disabled: true }),
      selectedList: new FormControl({ value: null, disabled: true }),
      selectedWorkshop: new FormControl({ value: null, disabled: false }),

      selectedDate: new FormControl({ value: null, disabled: this.dataParent.status == 'R' ? true : false }),
      selectedPackage: new FormControl({ value: this.dataParent?.package ?? 0, disabled: this.dataParent.status == 'R' ? true : false }),
      quantityPackage: new FormControl({ value: this.dataParent?.package ?? 0, disabled: true }),
      selectedAmount: new FormControl({ value: this.dataParent?.amount ?? 0, disabled: this.dataParent.status == 'R' ? true : false }),
      selectedQuantity: new FormControl({ value: 0 }),
      finalAmount: new FormControl({ value: 0 }),
      messageAudios: new FormControl(null),

      /** LOCMAT ELEMENTS */
      // selectedLocmatctlh: new FormControl({ value: null, disabled: true }),
      selectedLocmatctlm: new FormControl({ value: null, disabled: true }),
      selectedLocmatctld: new FormControl({ value: null, disabled: true }),

      /** DATE ELEMENTS */
      selectedMinDate1: new FormControl({ value: null, disabled: true }),
      selectedMaxDate1: new FormControl({ value: null, disabled: true }),
      selectedDocumentsView: new FormControl({ value: null, disabled: true }),
      selectedDocumentsViewLabel: new FormControl({ value: null, disabled: true }),
    });

    // Suscribe a los cambios del name
    this.globalUserDataForm.controls['selectedPackage'].valueChanges.subscribe(value => {
      console.log(value);
      this.globalUserDataForm.patchValue({
        quantityPackage: value,
      })
    });
    this.getConfigs();
  }

  /**
   * The function `getConfigs()` logs the values of `configForm` and `dataForm` in a formatted JSON
   * string.
   */
  getConfigs() {
    // console.debug("CX3 LGD - REACTIVE FORM (RAW VALUES): ", JSON.stringify(this.globalUserDataForm.getRawValue(), null, 2));

  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    //this.globalUserPreferences.preferences.currentUser = currentUser;

    this.getSecurity();

    this.isOnlyArticles = this.dataParent.isOnlyArticles;
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
            //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        error => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    this.getTranslatedLabels();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();

      await this.getLanguages();
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga ETIQUETAS, inténtelo más tarde' });
    }
  }

  /**
   * The function is an asynchronous function that fetches a list of languages and handles
   * any errors that occur during the process.
   */
  async getLanguages() {
    // // console.debug("CX3 LGD - LANGUAGES");

    const language = this.globalUserPreferences?.preferences?.language || null;
    const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

    try {
      const result = await this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, { language, storeId });

      if (result.success) {
        this.languages = result.data;

        if (language && storeId) {
          let selectedLanguage = this.languages.find(o => o.valueId === language);

          // NO EXISTE PARA ESA COORDINACION EL SELECCIONADO
          if (selectedLanguage == null && this.languages.length > 0) {
            selectedLanguage = this.languages[0];
          }

          this.globalUserDataForm.patchValue({
            selectedLanguage: selectedLanguage
          });

          await this.getInitData();
        }
      } else {
        console.error("An error occurred while fetching languages:", result);
        //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      //this.messageService.add({ severity: 'warn', summary: 'E/S MATERIAL DETALLE', detail: 'Se canceló carga LENGUAJES, inténtelo más tarde' });
    }
  }

  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination() {
    try {
      const storeId = this.globalUserPreferences?.preferences?.coordinationId || null;

      if (!storeId) {
        //console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const result = await this.tovpilCrudService.fetch(this.endPointGetStoreById, {
        storeId
      });

      if (result.success) {
        this.globalUserDataForm.patchValue({
          selectedCoordination: result.data?.storeId + ' ' + result.data?.descri,
          selectedCoordinationLevelId: result.data?.type ?? ''
        });
        return true;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        //this.handleError('CURRENCY Lista', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  async getValidPeriods() {
    try {

      const selLanguage = this.globalUserPreferences?.preferences?.language || null;

      if (!selLanguage) {
        //console.warn('Missing required parameters: storeId and languageId are necessary.');
        return false;
      }

      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, selLanguage);

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }
      const lstPeriod = data.data || []; // Handle empty data array

      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;

      const selectedPeriod = selPeriod?.year
        ? lstPeriod.find(period => period.year === selPeriod.year && period.period === selPeriod.period)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });

      return true;
    } catch (error) {
      console.error("Error in getValidPeriods:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function `getGuideById` asynchronously fetches guide data based on a selected guide ID and
   * updates the global user data form accordingly.
   * @returns This `getGuideById` async function returns a boolean value (`true` or `false`) based on the
   * success of fetching data and updating the value in the `globalUserDataForm`.
   */
  async getGuideById() {
    try {
      const selGuideId = this.dataParent.guideId || null;

      const data = await this.tovpilCrudService.fetch(this.endPointGetGuideById, {
        "guideId": selGuideId
      });

      if (!data.success) {
        //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        return false;
      }

      this.globalUserDataForm.patchValue({
        selectedGuide: data.data?.guideId + ' ' + data.data?.name + ' ' + data.data?.lastName
      });

      return true;
    } catch (error) {
      console.error("Error in getGuideById:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar los periodos. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      return false;
    }
  }

  /**
   * The function sets the minimum and maximum dates based on the current year and
   * period. This version includes error handling and better code structure for scalability.
   */
  async getDate() {
    try {
      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;
      if (!selPeriod) {
        return false;
      }

      const { year: currYear, period: currPeriod } = selPeriod;
      if (!currYear || !currPeriod) {
        return false;
      }

      // Validate period
      if (!["1", "2"].includes(currPeriod)) {
        return false;
      }

      // Define period format and dates
      const periodFormat = {
        "1": { start: "0101", end: "0630" },
        "2": { start: "0701", end: "1231" }
      };

      const startDate = `${currYear}${periodFormat[currPeriod].start}`;
      const endDate = `${currYear}${periodFormat[currPeriod].end}`;

      const minDate = this.tovUtilsService.convertStringToDate(startDate);
      const maxDate = this.tovUtilsService.convertStringToDate(endDate);

      if (!minDate || !maxDate) {
        return false;
      }
      const dateValue = this.tovUtilsService.convertStringToDate(this.dataParent?.date) ?? null;
      const today = new Date();
      const selectedDate = (today >= minDate && today <= maxDate) ? today : maxDate;

      this.globalUserDataForm.patchValue({
        selectedMinDate1: new Date(minDate),
        selectedMaxDate1: new Date(maxDate),
        selectedDate: dateValue ?? (selectedDate)
      });
      return true;


    } catch (error) {
      console.error("Error calculating min and max dates:", error.message);
      // Optionally, provide a fallback or default values
      this.globalUserDataForm.patchValue({
        selectedMinDate1: null,
        selectedMaxDate1: null
      });
      return false;
    }
  }

  /**
 * This TypeScript function asynchronously fetches workshop data based on selected criteria and handles
 * any errors that may occur.
 * @returns The `getWorkShopsLst` function is returning the data fetched from the `tovpilCrudService`
 * after making a request to the `endPointFindPeriodGuideDescrip`. If the request is successful
 * (`result.success` is true), it returns the `result.data`. If there is an error during the fetch
 * operation, it logs the error and returns null. If the request
 */
  async getSelectedWorkshopAndWorksId() {
    try {
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const selGuideId = this.dataParent.guideId || null;
      const selPeriod = this.globalUserPreferences?.preferences?.periodSelected?.period || null;
      const selYear = this.globalUserPreferences?.preferences?.periodSelected?.year || null;

      let data = await this.tovpilCrudService.fetch(this.endPointFindPeriodGuideDescrip, {
        storeId: selStoreId,
        guideId: selGuideId,
        currYear: selYear,
        currPeriod: selPeriod,
        language: selLanguage,
        zoneId: null
      });

      if (!data.success) {
        return false;
      }

      const lstWorkshops = data.data || []; // Handle empty data array

      const selWorkshop = this.globalUserDataForm.get("selectedWorkshop").value ?? null;


      const _selectedWorkshop = selWorkshop?.form0?.wrksId
        ? lstWorkshops.find(wrks => wrks?.form0?.wrksId === selWorkshop?.form0?.wrksId)
        : lstWorkshops[0]; // Default to first period if no selection or year missing

      const _selectedworksId = _selectedWorkshop?.form0?.wrksId ?? null;

      this.workshops = lstWorkshops;

      this.globalUserDataForm.patchValue({
        selectedWorkshop: _selectedWorkshop,
        selectedworksId: _selectedworksId
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * This TypeScript function asynchronously fetches the total price of a public pack list based on
   * selected workshop and list ID, handling errors and returning "S/N" if necessary.
   * @returns The function returns the total price from the fetched data if the
   * operation is successful. If there is an error during the fetching process or if the result is not
   * successful, it returns "S/N" (which likely stands for "Sin Número" or "No Number" in Spanish) and
   * logs the appropriate error messages.
   */
  async getSelectedPrice() {
    try {
      const selSerType = this.globalUserDataForm.get("selectedWorkshop").value?.form0?.serTyp || null;
      const selListId = this.globalUserDataForm.get("selectedLocmatctlm").value?.listId ?? this.globalUserDataForm.get("selectedList").value ?? null;

      let data = await this.tovpilCrudService.fetch(this.endPointGetPublicPackPriceLst, {
        serTyp: selSerType,
        listId: selListId,
      });

      if (!data.success) {
        return false;
      }

      const _selectedPrice = data.data?.total ?? 0.0;

      this.globalUserDataForm.patchValue({
        selectedPrice: _selectedPrice
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * This TypeScript function asynchronously fetches type details based on specified parameters and
   * handles any errors that may occur.
   * @returns The function is returning a Promise that resolves to either the
   * `result.data['value']` if the fetch operation is successful, or the string "S/N" if there is an
   * error during the fetch operation or if the result is not successful.
   */
  async getSelectedList() {
    try {

      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;

      let data = await this.tovpilCrudService.fetch(this.endPointGetGuideSelectedPriceLst, {
        storeId: selStoreId,
        language: selLanguage
      });

      if (!data.success) {
        return false;
      }

      const _selectedList = data.data?.value ?? 0.0;

      this.globalUserDataForm.patchValue({
        selectedList: _selectedList
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * This TypeScript function asynchronously fetches data based on field ID and value, updates the
   * selected component type in a form, and returns a boolean indicating success.
   * @param {string} _fieldId - The `_fieldId` parameter is a string that represents the ID of a field in
   * the data you are working with. It is used to identify a specific field for which you want to
   * retrieve information.
   * @param {string} _fieldValue - The `_fieldValue` parameter in the `getTypeDescri` function is a
   * string that represents the value of a field.
   * @returns The `getTypeDescri` function returns a boolean value - `true` if the data retrieval and
   * patching of form values are successful, and `false` if there is an error during the process.
   */
  async getSelectedComponentType(_fieldId: string, _fieldValue: string) {
    try {

      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const labelSalida = `${this.translations.lbl_delivery} ${this.translations.lbl_material}`;
      const labelEntrada = `${this.translations.lbl_return} ${this.translations.lbl_material}`;

      // console.log(_fieldValue);
      // let data = await this.tovpilCrudService.fetch(this.endPointSearchCategory, {
      //   fieldId: _fieldId,
      //   fieldVal: _fieldValue,
      //   language: selLanguage,
      //   zoneId: null
      // });

      // if (!data.success) {
      //   return false;
      // }

      const _selectedComponentType = _fieldValue == 'S' ? labelSalida : labelEntrada;

      this.globalUserDataForm.patchValue({
        selectedComponentType: _selectedComponentType
      });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getSelectedDocumentsView` updates the `selectedDocumentsView` and
   * `selectedDocumentsViewLabel` values in a form.
   * @returns The `getSelectedDocumentsView` function is returning a boolean value (`true` or `false`)
   * based on whether the form patching operation is successful or not. If the form patching is
   * successful, it will return `true`, otherwise it will return `false`.
   */
  async getSelectedDocumentsView() {
    try {
      this.globalUserDataForm.patchValue({
        selectedDocumentsView: true,
        selectedDocumentsViewLabel: "Ver Resumen"
      });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * This TypeScript function asynchronously fetches selected location material control header data based
   * on specified parameters and updates the global user data form accordingly.
   * @param {string} selDocId - The `selDocId` parameter is a string representing the selected document
   * ID.
   * @param {string} selWrksId - The parameter `selWrksId` appears to represent the selected work ID. It
   * is used as a part of the data payload sent to the `fetch` method of `tovpilCrudService` to retrieve
   * information related to a specific work.
   * @param {string} selStoreId - The `selStoreId` parameter in the `getSelectedLocmatctlh` function is
   * used to specify the store ID for fetching data. It is passed as an argument to the `fetch` method of
   * `tovpilCrudService` along with other parameters to retrieve information related to a
   * @param {string} selGuideId - The parameter `selGuideId` is used to specify the guide ID for
   * selecting a location material control header. It is passed as an argument to the
   * `getSelectedLocmatctlh` function to fetch data based on this guide ID.
   * @param {string} selOpt - The `selOpt` parameter in the `getSelectedLocmatctlh` function seems to
   * represent a status option. It is used to specify the status of the selected location material
   * control. The value of `selOpt` is passed to the API call to fetch data based on the specified
   * status.
   * @param {string} selListId - The parameter `selListId` is used to specify the list ID for fetching
   * selected location material control data. It is passed as an argument to the `getSelectedLocmatctlh`
   * function along with other parameters like `selDocId`, `selWrksId`, `selStoreId`,
   * @param {string} selLanguage - The `selLanguage` parameter in the `getSelectedLocmatctlh` function is
   * used to specify the language for which the location material control header data should be fetched.
   * It is passed as a string value representing the selected language.
   * @returns This function returns a boolean value - `true` if the data is successfully fetched and
   * updated in the `globalUserDataForm`, and `false` if there is an error during the process.
   * @deprecated
   */
  async getSelectedLocmatctlh(year: string | null, selWrksId: string | null, selStoreId: string | null, selGuideId: string | null, selOpt: string | null, selListId: string | null, selLanguage: string | null) {
    try {
      let data = await this.tovpilCrudService.fetch("", {
        "year": year,
        "wrksId": selWrksId,
        "storeId": selStoreId,
        "guideId": selGuideId,
        "status": selOpt,
        "listId": selListId,
        "language": selLanguage,
      });

      if (!data.success) {
        return false;
      }

      // this.globalUserDataForm.patchValue({
      //   selectedLocmatctlh: data?.data || null
      // });

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function asynchronously fetches data based on specified parameters and
   * updates the global user data form accordingly.
   * @param {string} selDocId - The `selDocId` parameter is a string that represents the document ID
   * being selected.
   * @param {string} selDocType - The `selDocType` parameter in the function is a
   * string that represents the type of document being selected. It is used as a parameter when fetching
   * data from the `tovpilCrudService` service.
   * @param {string} selSellType - The `selSellType` parameter in the  function is
   * used to specify the type of selling. It is passed as an argument to the function and then used in
   * the API call to fetch data based on the selected selling type.
   * @returns This function returns a boolean value - `true` if the data is successfully fetched and
   * updated in the `globalUserDataForm`, and `false` if there is an error during the process.
   */
  async getSelectedLocmatctlm(year: string | null, sequence: string | null, selGuideId: string | null, storeId: string | null,
    language: string | null, wrksId: string | null, docType: string | null) {
    try {
      if (year != null && sequence != null) {
        let data = await this.tovpilCrudService.fetch(this.endPointGetLocMatCtlMById, {
          "year": year,
          "sequence": sequence
        });

        if (!data.success) {
          return false;
        }
        this.globalUserDataForm.patchValue({
          selectedLocmatctlm: data?.data || null
        });
        return true;
      } else {
        const locmat: LocMatCtlM = {
          id: {
            year: null,
            sequence: null
          },
          guideId: selGuideId,
          storeId: storeId,
          language: language,
          wrksId: wrksId,
          docType: docType,
          listId: null,
          status: "N",
          currDate: this.tovUtilsService.dateToTovpilDate(new Date())
        };

        this.globalUserDataForm.patchValue({
          selectedLocmatctlm: locmat
        });
        return true;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The function `getLocMatCtlD` asynchronously fetches data related to a local material control using
   * specified parameters.
   * @param _itemId - _itemId is the ID of the item for which you want to retrieve data.
   * @param _sequence - The `_sequence` parameter in the `getLocMatCtlD` function is used to specify the
   * sequence of the item being requested. It is a numerical value that helps identify a specific item
   * within the context of the operation being performed.
   * @param _docId - _docId is a unique identifier for a document. It is used to specify which document
   * the function should retrieve information for.
   * @param _language - The `_language` parameter in the `getLocMatCtlD` function is used to specify the
   * language in which the data should be retrieved. It is passed as an argument to the function and then
   * included in the request to fetch data from the `endPointGetLocMatCtlD`. This allows
   * @returns The `getLocMatCtlD` function is returning the data fetched from the `tovpilCrudService` if
   * the fetch operation is successful. If there is an error during the fetch operation, it logs an error
   * message and returns `null`. If there is an error during the try block, it also logs the error and
   * returns `null`.
   * @deprecated
   */
  async getSelectedLocmatctld(itemId: string | null, sequence: string | null, year: string | null, language: string | null) {
    try {
      let data = await this.tovpilCrudService.fetch(this.endPointGetLocMatCtlD, {
        "itemId": itemId,
        "sequence": sequence,
        "year": year,
        "language": language
      });

      if (!data.success) {
        return false;
      }

      // console.debug("getSelectedLocmatctld(): " + data?.data);
      this.globalUserDataForm.patchValue({
        selectedLocmatctld: data?.data || null
      });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {

    const selYear = this.globalUserDataForm.get('selectedLocmatctlm').value?.id?.year || this.dataParent.year || null;
    const selWorksId = this.globalUserDataForm.get('selectedWorkshop').value?.form0?.wrksId || this.dataParent.wrksId || null;

    const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
    const selGuideId = this.dataParent.guideId || null;
    const selLanguage = this.globalUserPreferences?.preferences?.language || null;
    const selDocType = this.dataParent.docType || null;
    const selSeq = this.globalUserDataForm.get('selectedLocmatctlm').value?.id?.sequence || this.dataParent.sequence || null;

    try {
      const responseGetCoordination = await this.getCoordination();
      const responseGetPeriods = await this.getValidPeriods();
      const responseGetGuide = await this.getGuideById();
      const responseGetDate = await this.getDate();
      const responseGetWorkshops = await this.getSelectedWorkshopAndWorksId();
      const responseGetList = await this.getSelectedList();
      const responseGetComponentType = await this.getSelectedComponentType("entryType", this.dataParent.docType ?? null);
      const responseGetDocumentsView = await this.getSelectedDocumentsView();
      const responseGetPrice = await this.getSelectedPrice();
      // const responseGetLocMatCtlH = await this.getSelectedLocmatctlh(selDocId, selWorksId, selStoreId, selGuideId, null, null, selLanguage);

      const responseGetLocMatCtlM = await this.getSelectedLocmatctlm(selYear, selSeq, selGuideId, selStoreId, selLanguage, selWorksId, selDocType);
      const responseSetSelectedWorkshop = await this.selectStage();
      if (responseGetCoordination && responseGetPeriods && responseGetGuide && responseGetDate && responseGetWorkshops && responseGetPrice && responseGetList && responseGetComponentType && responseGetDocumentsView && responseGetLocMatCtlM) {
        this.getConfigs();
        await this.loadData();
      } else {
        console.error("An error occurred while fetching price list:", responseGetCoordination, responseGetPeriods, responseGetGuide, responseGetDate, responseGetWorkshops, responseGetPrice, responseGetList, responseGetComponentType, responseGetDocumentsView);
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
      }
    } catch (error) {
      console.error("An error occurred while fetching price list:", error);
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    }
  }


  /**
   * The function `reloadData` asynchronously reloads a list of services, displaying an error
   * message if the operation fails.
   */
  async reloadData() {
    try {
      this.blocked = true;
      const servsResponse = await this.getInputOutputDtl();
      if (servsResponse) {
        this.blocked = false;
      } else {
        console.error("Error recargando list serve");
        //this.messageService.add({ severity: 'warn', summary: 'REGISTRO CARGOS POR MATERIAL (E/S LOC)', detail: 'Se canceló carga de datos, inténtelo más tarde' });
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      console.error("Error recargando list serve");
      //this.messageService.add({ severity: 'warn', summary: 'REGISTRO CARGOS POR MATERIAL (E/S LOC)', detail: 'Se canceló carga de datos, inténtelo más tarde' });
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  selectStage() {
    const selType = this.globalUserDataForm.get('selectedLocmatctlm').value?.sellType;
    if (selType === '1' || selType === '2' || selType === '3') {

      const stage = (parseInt(this.globalUserDataForm.get('selectedLocmatctlm').value?.sellType) + 15).toString();
      console.log(stage);
      const _selectedWorkshop = this.workshops.find(wrks => wrks?.form0?.wrksId === stage);


      this.globalUserDataForm.patchValue({
        selectedWorkshop: _selectedWorkshop,
      });
    }
  }

  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData() {

    if (!this.globalUserDataForm.valid) {
      return;
    }

    try {
      this.blocked = true;
      const salesResponse = await this.getInputOutputDtl();

      if (salesResponse) {
        // console.debug("CX3 LGD - LOAD DATA: ", salesResponse);
        this.blocked = false;
      } else {
        //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
        this.blocked = false;
      }
    } catch (error) {
      console.error(error);
      this.blocked = false;
      //this.handleError('FII List', 'Hubo un problema al procesar la información. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } finally {
      setTimeout(() => {
      }, 1500);
    }
  }

  toggleIsOnlyArticles() {
    this.isButtonClicked = true;
    this.isOnlyArticles = !this.isOnlyArticles;
    this.reloadData();
  }

  /**
   * The function is an asynchronous function that fetches a list of sales data and
   * handles success and error cases.
   * @returns a Promise object.
   */
  async getInputOutputDtl() {
    let isStage = false;
    const form0 = this.globalUserDataForm.get("selectedWorkshop").value?.form0?.wrksId ?? null;
    try {
      // if ((form0.wrksId === '16' || form0.wrksId === '17' || form0.wrksId === '18') && this.globalUserDataForm.get("selectedWorkshop").value?.descrip != null) {
      //   isStage = true;
      // }
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const selGuideId = this.dataParent.guideId || null;

      const selYear = this.globalUserDataForm.get('selectedLocmatctlm').value?.id?.year || this.dataParent.year || null;
      const selWrksId = this.globalUserDataForm.get('selectedWorkshop').value?.form0?.wrksId || this.dataParent.wrksId || null;

      const sequence = this.globalUserDataForm.get('selectedLocmatctlm').value?.id?.sequence || this.dataParent.sequence || null;
      const reqQty = this.globalUserDataForm.get('selectedPackage').value || null;

      return new Promise((resolve, reject) => {
        this.tovpilCrudService.fetch(this.endPointGetReqMat, {
          storeId: selStoreId,
          language: selLanguage,
          year: selYear,
          sequence: sequence,
          wrksId: this.isOnlyArticles ? null : selWrksId,
          reqQty: reqQty,
          guideId: selGuideId
        }).then(result => {
          // console.debug("CX3 LGD: ", result)
          if (result.success) {
            this.handleSuccessInputOutputDtl(result.data);
            resolve(true);
          } else {
            console.error("An error occurred while fetching purchase order data:");
            resolve(false);
          }
        }).catch(error => {
          console.error(error);
          reject(error);
        });
      });
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /**
   * The ?? function in TypeScript processes an array of data to calculate prices, quantities,
   * and amounts for material requirements, and then generates a total summary.
   * @param {any[]} _data - The ?? function takes an array `_data` as a parameter. It then
   * processes each item in the array to calculate prices, quantities, amounts, and other properties for
   * each item. Finally, it calculates the total quantities and amounts for all items in the array and
   * adds a total item to
   */
  async parseDate(_data: any[]) {

    // !IMPORTANT TO MANAGE DATA IN GENERAL PARSE
    const extractValue = (controlName: string, defaultValue: number = 0) =>
      this.globalUserDataForm.get(controlName).value ?? defaultValue;
    const priceOrDefault = (item: any) => item?.price ?? 0.00;
    const reqQtyOrDefault = (item: any) => item?.matd?.reqQty ?? 0.00;

    const materialReqLst = _data.map((reqMatGuide: any) => {
      const price = priceOrDefault(reqMatGuide);
      const reqQty = reqQtyOrDefault(reqMatGuide);
      const amount = price * reqQty;

      return {
        ...reqMatGuide,
        price,
        matd: { ...reqMatGuide.matd, reqQty },
        amount,
        canEdit: reqMatGuide?.editItem ?? false,
        isServiceModify: amount > 0 || (reqMatGuide?.matd?.reqQty != null && reqMatGuide?.matd?.reqQty > 0)
      };
    });

    let totalReqQty = 0.00;
    let totalPrice = 0.00;
    let amountFinal = 0.00;

    // SE OBTIENE COSTO SERVICIO
    const _publicPrice = extractValue('selectedPrice');
    const _packagePlay = extractValue('selectedPackage');
    const _totalInitial = _packagePlay * _publicPrice;

    // ITEMS SIN SERVICIO
    const _totalAmountS = (
      materialReqLst
        .filter(item => item?.wkrsId === null)
        .reduce((total, item) => total + parseFloat(item?.amount || 0.00), 0.00)
    );

    // ITEM CON SERVICIO
    const _totalAmount = (
      materialReqLst
        .filter(item => item?.wkrsId != null)
        .reduce((total, item) => total + parseFloat(item?.amount || 0.00), 0.00)
    );


    // REGLA DE IMPORTE
    const _ruleAmount = this.workshops != null && this.workshops.length > 0 && (this.globalUserDataForm.get('selectedWorkshop').value) != null;

    // IMPORTE ( TRUE: SERVICIO, FALSE: SIN SERVICIO)
    amountFinal = _ruleAmount ? (_totalInitial) + (_totalAmountS) : (_totalAmount) + (_totalAmountS);

    // INDICA QUE NO TIENE IMPORTE (CREAR) TRUE: CREATE , FALSE :UPDATE
    const _opt = extractValue('selectedAmount') != null && extractValue('selectedAmount') == 0 && amountFinal == 0;

    amountFinal = _opt ? this.globalUserDataForm.get('selectedAmount').value : amountFinal;

    // CALCULA PARA TOTALES 
    totalReqQty = materialReqLst
      .filter(item => item?.isServiceModify)
      .reduce((total, item) => total + parseFloat(item?.matd?.reqQty || 0.00), 0.00);

    totalPrice = materialReqLst
      .filter(item => item?.isServiceModify)
      .reduce((total, item) => total + parseFloat(item?.price || 0.00), 0.00);


    // ESTABLECE VALORES
    this.materials = materialReqLst;
    this.materialsTotal = this.filterMaterialReqList(this.materials, item => item?.isServiceModify === true);

    this.globalUserDataForm.patchValue({
      selectedAmount: amountFinal,
      selectedQuantity: totalReqQty
    });
  }

  /**
   * The function handles the success response of a sales list and extracts the
   * columns dynamically from the JSON data.
   * @param {any[]} data - An array of objects containing sales data.
   */
  async handleSuccessInputOutputDtl(data: any[]) {
    if (data.length > 0) {

      this.parseDate(data);

      // console.debug("CX3 LGD PUBLIC MATERIAL : ", this.materials);
      // console.debug("CX3 LGD PUBLIC MATERIAL TOTAL: ", this.materialsTotal);

      // let response5 = await this.initLocMatCtl();
      // console.debug("CX3 LGD PUBLIC MATERIAL LOCMATH: ", this.globalUserDataForm.get('selectedLocmatctlh').value)
      // console.debug("CX3 LGD PUBLIC MATERIAL LOCMATM: ", this.globalUserDataForm.get('selectedLocmatctlm').value)

    } else {
      this.materials = null;
    }
  }

  /**
   * The exportExcel function checks if a list exists and is not empty, then maps the list items to a new
   * JSON format and exports it to an Excel file.
   */
  exportExcel() {
    let materialReqLst = this.materials || null;
    if (materialReqLst === null) {
      // Lista no existe
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else if (materialReqLst.length < 1) {
      // Lista Vacia
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else {
      const filteredJSON = materialReqLst.map((item) => ({
        "ID_ARTICULO": item ? (item?.itemId || 'S/N') : 'S/N',
        "DESCRIPCION": item ? (item?.descri || 'S/N') : 'S/N',
        "CANTIDAD": item ? (item?.matd?.reqQty || 'S/N') : 'S/N',
        "PRECIO": item ? (item?.price || 'S/N') : 'S/N',
        "IMPORTE": item ? (item?.amount || 'S/N') : 'S/N'
      }));
      this.filesService.tovpilExportXLSX(filteredJSON, this.translations.lbl_list + '_' + this.translations.lbl_of + '_' + this.translations.lbl_items + "_");
    }
  }

  /**
   * The `exportPdf` function checks if a list exists and is not empty, then formats the data and
   * exports it to a PDF file.
   */
  exportPdf() {
    let materialReqLst = this.materials || null;
    if (materialReqLst === null) {
      // Error de lista no existe
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else if (materialReqLst.length < 1) {
      // Error de lista vacía
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_list} ${this.translations.lbl_is_not_valid}`, life: 3000 });
    } else {
      const filteredJSON = materialReqLst.map((item) => ({
        "ID_ARTICULO": item ? (item?.itemId || 'S/N') : 'S/N',
        "DESCRIPCION": item ? (item?.descri || 'S/N') : 'S/N',
        "CANTIDAD": item ? (item?.matd?.reqQty || 'S/N') : 'S/N',
        "PRECIO": item ? (item?.price || 'S/N') : 'S/N',
        "IMPORTE": item ? (item?.amount || 'S/N') : 'S/N'
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, this.translations.lbl_list + '_' + this.translations.lbl_of + '_' + this.translations.lbl_items + "_");
    }
  }

  /**
   * The function `goBack` is an asynchronous function in TypeScript that handles navigation to a
   * specific URL with query parameters and ensures navigation happens even if an error occurs.
   */
  async goBack() {
    try {
      // Intentamos ejecutar confirmationBackAndSave, pero no dejamos que su error afecte la navegación.
      // this.createByInitialButton();
    } catch (error) {
      console.error("An error occurred in confirmationBackAndSave:", error);
    } finally {
      // Este bloque se ejecutará siempre, incluso si hubo un error en confirmationBackAndSave.
      let queryParams = {
        guideId: this.dataParent.guideId || null,
        type: this.dataParent.type
      };

      try {
        let stringRedirect = '/treasurer/locMatCtlLstM';
        const url = this.urlBuilderService.buildUrl(stringRedirect, queryParams);

        // Navegamos a la ruta deseada con los parámetros de consulta
        this.router.navigateByUrl(url);
      } catch (navigationError) {
        console.error("An error occurred while navigating:", navigationError);
        this.messageService.add({
          severity: 'warn',
          summary: this.translations.lbl_material_payment_registry_Loc,
          detail: Constants.SUCCESS_MESSAGE,
          life: 5000
        });
      }
    }
  }

  /**
   * The function `confirmationBackAndSave` confirms with the user if they want to save changes,
   * and if confirmed, it saves before navigating back.
   */
  async confirmationBackAndSave() {
    return new Promise<void>((resolve, reject) => {
      try {
        this.confirmationService.confirm({
          message: `¿ ${this.translations.lbl_are_you_sure} ${this.translations.lbl_save_order} ?`,
          header: this.translations.lbl_confirm,
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            try {
              // Guardamos antes de salir
              this.createByInitialButton();
              resolve(); // Se confirma y se completa la promesa
            } catch (error) {
              console.error("An error occurred during save:", error);
              reject(error); // Rechazamos si hay un error en el guardado
            }
          },
          reject: () => {
            resolve(); // Si el usuario cancela, también resolvemos la promesa
          }
        });
      } catch (error) {
        console.error("An error occurred in confirmation:", error);
        reject(error); // Rechazamos si hay un error en la confirmación
      }
    });
  }


  /**
   * The `toggleView` function toggles the `documentsView` boolean property and updates the
   * `documentsViewLabel` string property accordingly.
   */
  toggleView() {
    this.globalUserDataForm.patchValue({
      selectedDocumentsView: !this.globalUserDataForm.get('selectedDocumentsView').value,
      selectedDocumentsViewLabel: this.globalUserDataForm.get('selectedDocumentsView').value ? `${this.translations.lbl_show} ${this.translations.lbl_all} ${this.translations.lbl_items}` : 'Ver resumen',
    })
  }

  /** COMPONENTS LOGIC */

  /** UPDATE & DELETE BUTTON */

  /**
   * The `deleteRecord` function asynchronously deletes a record using a service, displaying success or
   * error messages accordingly.
   */
  async deleteRecord() {
    try {
      this.confirmationService.confirm({
        message: `¿Estas seguro de eliminar el registro?`,
        header: this.translations.lbl_confirm,
        icon: 'pi pi-exclamation-triangle',
        accept: async () => {
          this.blocked = true;
          let result = await this.tovpilCrudService.fetch(this.endPointRemoveRecordLocmatcM, {
            "locMatCtlM": this.globalUserDataForm.get('selectedLocmatctlm').value
          });

          if (result.success && result.data['id'] != null) {
            this.blocked = false;
            this.messageService.add({ severity: 'success', summary: `${this.translations.lbl_record} ${this.translations.lbl_deleted}`, life: 3000 });
            this.goBack();
          } else {
            this.blocked = false;
            console.error("An error occurred while fetching purchase order data:");
          }
        },
        reject: () => {
        }
      });
    } catch (e) {
      this.blocked = false;
      console.error("An error occurred while fetching purchase order data:");
    }
  }

  async createByInitialButton() {
    this.blocked = true;
    let isEmpty = this.validateEmptyOrder();
    if (isEmpty == true) {
      this.messageService.add({ severity: 'warn', summary: `${this.translations.lbl_unable} ${this.translations.lbl_to} ${this.translations.lbl_create} ${this.translations.lbl_record} ${this.translations.lbl_without} ${this.translations.lbl_registered_workshops}  ${this.translations.lbl_quantity} ${this.translations.lbl_and} ${this.translations.lbl_or} ${this.translations.lbl_total}`, life: 3000 });
      this.blocked = false;
      return;
    }
    this.blocked = false;
    this.updateLocMatCtlHM();
  }

  /**
   * The function `updateLocMatCtlHM` in TypeScript updates local material control header and detail
   * records based on certain conditions and displays a success or error message accordingly.
   */
  async updateLocMatCtlHM() {
    this.blocked = true;

    // console.debug("CX3 LGD PUBLIC MATERIAL UPDATELOCMATCTLHM");
    try {
      const selAmount = this.globalUserDataForm.get('selectedAmount').value ?? 0.0;

      // GET & UPDATE LOCMATCTLM
      const responseMC = await this.updateLocMatCtlM(selAmount);
      // console.debug("CX3 LGD PUBLIC MATERIAL UPDATELOCMATCTLHM - MC : ", responseMC);

      // UPDATE LOCMATCLTH & LOCMATCTLM
      this.globalUserDataForm.patchValue({
        selectedLocmatctlm: responseMC
      });

      const message = responseMC === null ? this.translations.lbl_internal_server_error : this.translations.lbl_updated_data;
      const severity = responseMC === null ? 'warning' : 'success';
      this.messageService.add({ severity: severity, summary: this.translations.lbl_material_payment_registry_Loc, detail: message, life: 5000 });
      this.blocked = false;

      // this.reloadData();
      await this.loadData();
    } catch (error) {
      console.error(error);
      this.blocked = false;
    }
    this.blocked = false;

  }

  /**
   * This TypeScript function updates local material control header information asynchronously.
   * @param _wrksId - _wrksId is the ID of a work or project.
   * @param _storeId - The `_storeId` parameter in the `updateLocMatCtlH` function represents the ID of
   * the store for which the local material control header is being updated. It is used as a reference to
   * identify the specific store within the system.
   * @param _guideId - The `_guideId` parameter in the `updateLocMatCtlH` function is used to specify the
   * guide ID for updating the local material control header. It is passed as an argument to the function
   * and then included in the request payload sent to the `tovpilCrudService.fetch` method
   * @param _listId - The `_listId` parameter in the `updateLocMatCtlH` function is used to specify the
   * list ID for updating the local material control header. It is passed as an argument to the function
   * and then included in the request payload when fetching data from the `endPointUpdtaCreateLoc
   * @param _language - The `_language` parameter in the `updateLocMatCtlH` function represents the
   * language setting for the operation. It is used to specify the language in which the data should be
   * retrieved or processed.
   * @param _opt - The `_opt` parameter in the `updateLocMatCtlH` function is used to specify the status
   * for updating the Local Material Control Header. It is passed as an argument to the function and then
   * included in the request payload sent to the `tovpilCrudService.fetch` method. The
   * @returns The `updateLocMatCtlH` function returns the data fetched from the `tovpilCrudService` if
   * the fetch operation is successful. If there is an error during the fetch operation, it logs an error
   * message and returns `null`. If there is an error during the try block, it also logs the error and
   * returns `null`.
   */
  // async updateLocMatCtlH(_docId, _wrksId, _storeId, _guideId, _listId, _language, _status, _opt) {
  //   try {
  //     let result = await this.tovpilCrudService.fetch(this.endPointUpdtaCreateLocMatCltH, {
  //       "docId": _docId,
  //       "wrksId": _wrksId,
  //       "storeId": _storeId,
  //       "guideId": _guideId,
  //       "status": _status,
  //       "listId": _listId,
  //       "language": _language,
  //       "opt": _opt
  //     });

  //     if (result.success) {
  //       return result.data;
  //     } else {
  //       console.error("An error occurred while fetching purchase order data:");
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return null;
  //   }
  // }

  /**
   * The function  asynchronously updates local material control data with specified
   * parameters.
   * @param _docId - _docId is the unique identifier of the document that needs to be updated in the
   * Local Material Client Master.
   * @param _docType - It seems like you were about to provide a description of the `_docType` parameter,
   * but the description is missing. Could you please provide more information about what the `_docType`
   * parameter represents or is used for in the  function?
   * @param _sellType - _sellType is a parameter that represents the type of sale for a particular
   * document. It could be a string or a code indicating the type of sale, such as retail, wholesale,
   * online, etc.
   * @param _packNum - The `_packNum` parameter in the  function appears to represent
   * the package number. It is used as a parameter when calling the `fetch` method to update/create Local
   * Material Client data. This parameter likely identifies a specific package associated with the
   * document being processed.
   * @param _period - The `_period` parameter in the  function appears to represent a
   * period related to the document being updated. It could be a specific time frame, duration, or cycle
   * associated with the document. The exact meaning and usage of this parameter would depend on the
   * context and requirements of
   * @param _status - The `_status` parameter in the  function represents the status of
   * a document or transaction. It could indicate whether the document is pending, approved, rejected, or
   * any other relevant status in the context of the application. This parameter is used to update the
   * status of a Local
   * @param _totAmt - The `_totAmt` parameter in the  function represents the total
   * amount associated with the document or transaction being updated. It is used to store the total
   * monetary value related to the specific document or operation.
   * @param _cancelSts - The `_cancelSts` parameter in the  function appears to
   * represent the cancellation status of a document or transaction. It is likely used to indicate
   * whether the document has been canceled or not.
   * @param _currDate - The `_currDate` parameter in the  function represents the
   * current date that is being passed as a parameter for updating the Local Material Control Master. It
   * is used to indicate the date at which the update operation is being performed.
   * @returns The function  returns the data fetched from the `tovpilCrudService` if
   * the fetch operation is successful. If there is an error during the fetch operation or if the result
   * is not successful, an error message is logged and `null` is returned.
   */
  async updateLocMatCtlM(selAmount) {
    const selYear = this.globalUserDataForm.get('selectedLocmatctlm').value?.id?.year || this.dataParent.year || null;
    const selSeq = this.globalUserDataForm.get('selectedLocmatctlm').value?.id?.sequence || null;

    // Numero de unidades (Items Individuales)
    const unitNum = this.filterMaterialReqList(this.materials, item => item?.isServiceModify === true)
      .reduce((total, item) => total + (parseFloat(item?.matd?.reqQty || '0') || 0), 0);

    // Numero de paquetes (Unidades de paquetes)
    const packNum = this.globalUserDataForm.get('selectedPackage').value || 0;

    try {
      const lcmTmp: LocMatCtlM = await this.apiService.getLocmatctlmById({
        "year": selYear ?? null,
        "sequence": selSeq ?? null
      });

      if (lcmTmp == null)
        return null;

      lcmTmp.totAmt = selAmount;
      lcmTmp.unitNum = unitNum;
      lcmTmp.packNum = packNum;
      lcmTmp.currDate = this.tovUtilsService.dateToTovpilDate(this.globalUserDataForm.get('selectedDate').value);

      let result = await this.apiService.updateLocmatctlm(lcmTmp);
      if (result != null) {
       this.messageService.add({ severity: 'success', summary: this.translations.lbl_information, detail:  this.translations.lbl_updated_data, life: 5000 });
        return result;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        return null;
      }

    } catch (error) {
      console.error(error);
      return null;
    }
  }

  /**
   * This TypeScript function updates a record for a local material control detail with specified
   * parameters.
   * @param _itemId - _itemId is the ID of the item being updated in the local material control.
   * @param _sequence - The `_sequence` parameter in the  function is used to specify
   * the sequence of the item being updated. It helps in identifying the specific item within the context
   * of the operation being performed.
   * @param _docId - The `_docId` parameter in the function appears to represent the
   * document ID associated with the operation. This parameter is used as part of the data payload sent
   * to the `fetch` method of `tovpilCrudService` for updating or creating local material control
   * @param _language - The `_language` parameter in the function represents the
   * language in which the data should be processed or displayed. It is used as part of the request
   * payload when calling the `fetch` method of `tovpilCrudService`. This parameter allows the function
   * to handle
   * @param _reqQty - The `_reqQty` parameter in the function represents the required
   * quantity of an item that needs to be updated in the Local Material Control Details. This value is
   * used to specify the quantity of the item that is being requested or processed in the system.
   * @returns The  function returns the data fetched from the `tovpilCrudService` if
   * the fetch operation is successful. If there is an error during the fetch operation, it logs an error
   * message and returns `null`. If there is an error during the try block, it also logs the error and
   * returns `null`.
   * @deprecated
   */
  async updateLocMatCtlD(itemId: string, sequence: string, year: string, language: string, reqQty: string, opt: string) {
    try {
      let result = await this.tovpilCrudService.fetch(this.endPointUpdtaCreateLocMatCltD, {
        "itemId": itemId,
        "sequence": sequence,
        "year": year,
        "language": language,
        "reqQty": reqQty,
        "opt": opt
      });

      if (result.success) {
        return result.data;
      } else {
        console.error("An error occurred while fetching purchase order data:");
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  /** CREATE FROM TABLE */

  /**
   * The function onRowEditInit() is used to initialize row editing in TypeScript.
   */
  onRowEditInit(reqMatGuide: any) {
    if (this.editingRow) {
      return;
    }
    this.editingRow = reqMatGuide;
  }

  maxOnHand(reqMatGuide: any): number {
    return reqMatGuide?.onHand ? parseFloat(reqMatGuide.onHand) : 0;
  }
  /**
   * The function onRowEditInit() is used to initialize row editing in TypeScript.
   */
  saveUpdatePriceItem(reqMatGuide: any) {
    this.updateItem(reqMatGuide);
  }

  /**
   * The function onRowEditCancel() is used to handle the cancellation of row editing.
   */
  onRowEditCancel() {
    // NOTHING TO DO
    this.editingRow = null;
  }

  /**
   * The function  in TypeScript asynchronously updates item information based on various
   * parameters and API responses.
   * @param {any} reqMatGuide - The `reqQty` parameter in the function represents the quantity of
   * an item that needs to be updated or created in the system. This quantity will be used in the process
   * of updating or creating records in the Loc Mat Ctl D (Local Material Control Detail) table.
   */
  async updateItem(reqMatGuide: any) {
    try {
      this.blocked = true;
      let _reqQty = reqMatGuide?.matd?.reqQty ?? 0;
      const _reqOnHand = reqMatGuide?.onHand ?? 0;
      let inventUpd = reqMatGuide?.itm?.inventUpd ?? true;

      const validator = await this.validator(_reqQty);

      if (validator === false) {
        this.reloadData();
        this.blocked = false;
        return;
      }

      if (_reqQty > _reqOnHand && inventUpd == true) {
        this.messageService.add({
          severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`,
          detail: `${this.translations.lbl_quantity} ${this.translations.lbl_greater_than} ${this.translations.lbl_inventory}, ${this.translations.lbl_showing} ${this.translations.lbl_inventory} ${this.translations.lbl_available}`
        });
        _reqQty = _reqOnHand;
      }

      let max = this.globalUserDataForm.get('selectedPackage').value ?? null;
      let wrksId = reqMatGuide?.wkrsId;

      if (wrksId != null && _reqQty > max) {
        this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_quantity} ${this.translations.lbl_greater_than} ${this.translations.lbl_set}` });
      }

      if (wrksId != null && _reqQty > max * 1.2) {
        this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_quantity} ${this.translations.lbl_greater_than} 20% ${this.translations.lbl_of} ${this.translations.lbl_total} ${this.translations.lbl_set}` });
      }

      const selWorksId = this.globalUserDataForm.get('selectedWorkshop').value?.form0?.wrksId || this.dataParent.wrksId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      let selAmount = this.globalUserDataForm.get('selectedAmount').value ?? 0.0;
      const itemId = reqMatGuide.matd.id?.itemId ?? reqMatGuide.itm.itemId;

      // GET & UPDATE LOCMATCTLM
      const responseM = this.globalUserDataForm.get('selectedLocmatctlm').value ?? null;
      const responseCrud = await this.updateOrder(responseM, itemId, selLanguage, _reqQty, selAmount, selWorksId);

      // UPDATE LOCMATCLTH & LOCMATCTLM
      await this.updateLocMatCtlM(this.globalUserDataForm.get("finalAmount").value);
      this.editingRow = null;

    } catch (error) {
      console.error(error);
      this.editingRow = null;
      this.blocked = false;
    }
    await this.getInitData();
  }


  async updateOrder(locM: LocMatCtlM, itemId, language, reqQty, totAmt, worksId) {
    let result = true;
    try {
      const year = locM?.id?.year ?? null;
      const sequence = locM?.id?.sequence ?? null;
      locM.totAmt = totAmt;
      locM.wrksId = worksId;

      let locD: LocMatCtlD = {
        id: {
          itemId: itemId,
          year: year,
          sequence: sequence,
        },
        reqQty: reqQty,
      };

      let res = await this.apiService.crudLocMatCtl({
        locM: locM,
        locD: locD,
        language: language,
        method: "UPDATE",
      });

      if (res.status == 'ERROR') {
        this.messageService.add({ severity: 'warn', summary: this.translations.lbl_information, detail: res.errorMessage, life: 5000 });
        result = null;
      }

      let finalPrice = res.lstMrd.reduce((total, item) => total + (parseFloat(item?.matd?.reqQty || 0.00) * parseFloat(item?.matd?.price || 0.00)), 0.00);
      this.globalUserDataForm.patchValue({
        selectedLocmatctlm: res?.locM || null,
        finalAmount: finalPrice,
      });

      return result;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  /**
   * The function `validator` in TypeScript checks if certain conditions are met and returns a boolean
   * value based on the validation result.
   * @param {number} reqQty - The `reqQty` parameter in the `validator` function represents the quantity
   * that needs to be validated. The function checks various conditions related to the delivery date,
   * current date, and play package number to determine if the quantity is valid. If any of the
   * conditions are not met, an error message is
   * @returns The `validator` function is returning a boolean value (`true` or `false`) based on the
   * conditions checked in the function. If there are no error messages (`errMsg.length <= 0`), then it
   * returns `true`, indicating that the validation was successful. If there are any error messages, it
   * returns `false` and also displays an error message using `messageService.add`.
   */
  async validator(reqQty: number): Promise<boolean> {
    try {
      let result = false;
      let errMsg: string | null = "";
      let date1 = this.globalUserDataForm.get('selectedDate').value ?? null;
      let current = new Date().getTime();
      let _packNum = this.globalUserDataForm.get('selectedPackage').value ?? 0;

      if (date1 == null) {
        errMsg = `${this.translations.lbl_select} ${this.translations.lbl_date} ${this.translations.lbl_valid}`;
      } else if (date1.getTime() >= current) { // Compare in milliseconds
        errMsg = `${this.translations.lbl_date} ${this.translations.lbl_must} ${this.translations.lbl_be} ${this.translations.lbl_lower_than} ${this.translations.lbl_or} ${this.translations.lbl_equals_to} ${this.translations.lbl_current}`;
      } else if (_packNum < 0) {
        errMsg = `${this.translations.lbl_insert} # ${this.translations.lbl_set} ${this.translations.lbl_greater_than} 0`;
      } else if (reqQty < 0) {
        errMsg = `${this.translations.lbl_insert} ${this.translations.lbl_valid} ${this.translations.lbl_quantity}`;
      }

      if (errMsg.length <= 0) {
        result = true;
      } else {
        this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: errMsg });
      }

      return result;

    } catch (error) {
      console.error(error);
      return false;
    }
  }

  /** DIALOG APPROVE */

  /**
   * The function  displays a modal for confirmation and disables certain form
   * fields.
   */
  displayConfirmationView() {
    this.confirmationService.confirm({
      message: `¿Antes de aprobar guarda/actualiza la informacion y verifica los totales?`,
      header: this.translations.lbl_confirm,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        // !IMPORTANT TO MANAGE DATA IN GENERAL PARSE
        const extractValue = (controlName: string, defaultValue: number = 0) =>
          this.globalUserDataForm.get(controlName).value ?? defaultValue;

        if (
          this.globalUserDataForm.get('selectedLocmatctlm').value === null) {
          this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_is_not_allowed} ${this.translations.lbl_update} ${this.translations.lbl_item}` });
          return;
        }


        const disableFormControls = (...controlNames: string[]) => {
          controlNames.forEach(controlName => {
            this.globalUserDataForm.get(controlName).disable();
          });
        };

        this.materialsTmp = this.materials ?? [{}];
        const matReqLst = this.materials ?? [{}];
        const matReqLstTotal = this.materialsTotal ?? [{}];

        this.materials = matReqLst;
        this.materialsTotal = matReqLstTotal;


        const filteredMaterialReqLst = this.filterMaterialReqList(matReqLst, item => item?.isServiceModify === true);

        const _publicPrice = extractValue('selectedPrice');
        const _packagePlay = extractValue('selectedPackage');


        const _totalInitial = _packagePlay * _publicPrice;

        const _totalAmountS = filteredMaterialReqLst
          .filter(item => item?.wkrsId === null)
          .reduce((total, item) => total + parseFloat(item?.amount || 0.00), 0.00);

        const _totalAmount = filteredMaterialReqLst
          .reduce((total, item) => total + parseFloat(item?.amount || 0.00), 0.00)
          .toFixed(2);

        const _ruleAmount = this.workshops != null && this.workshops.length > 0 && (this.globalUserDataForm.get('selectedWorkshop').value) != null;


        let amountFinal = _ruleAmount ? _totalInitial + _totalAmountS : _totalAmount;

        // INDICA QUE NO TIENE IMPORTE (CREAR) TRUE: CREATE , FALSE :UPDATE
        const _opt = extractValue('selectedAmount') != null && extractValue('selectedAmount') == 0 && amountFinal == 0;
        amountFinal = _opt ? this.globalUserDataForm.get('selectedAmount').value : amountFinal;

        const totalReqQty = filteredMaterialReqLst
          .filter(item => item?.isServiceModify)
          .reduce((total, item) => total + parseFloat(item?.matd?.reqQty || 0.00), 0.00);

        const totalPrice = filteredMaterialReqLst
          .filter(item => item?.isServiceModify)
          .reduce((total, item) => total + parseFloat(item?.price || 0.00), 0.00);

        // SETTING 
        this.materials = filteredMaterialReqLst;

        this.checkGrantAudio();

        disableFormControls('selectedDate', 'selectedWorkshop', 'selectedPackage', 'selectedAmount');
        this.displayModalApprove = true;

        // console.debug("CX3 LGD PUBLIC MATERIALS: ", this.materials);
      },
      reject: () => {
      }
    });
  }

  async checkGrantAudio() {
    const year = this.globalUserDataForm.get("selectedLocmatctlm")?.value.id.year;
    const sequence = this.globalUserDataForm.get("selectedLocmatctlm").value.id.sequence;
    const res = await this.apiService.checkGrantAudioPlay({
      "year": year,
      "sequence": sequence,
      "type": "V"
    });

    if (res.lstValues?.length > 0) {

      this.globalUserDataForm.patchValue({
        messageAudios: `Se otorgará derecho de reproducción a los artículos/ It will grant to access audio play: ${res.lstValues.join(', ')} opción (dwdAV)`,
      });

      console.log(this.globalUserDataForm.get("messageAudios").value);
    }
  }

  /**
   * Función de filtro para filtrar elementos de la lista de solicitudes de material según un criterio.
   * @param {Object[]} matReqLst La lista de solicitudes de material a filtrar.
   * @param {Function} filterFn La función de filtro que define el criterio de filtrado.
   * @returns {Object[]} La lista filtrada de solicitudes de material.
   */
  filterMaterialReqList(matReqLst, filterFn) {
    return matReqLst.filter(filterFn);
  }

  /**
   * The function disables a modal and enables certain form fields.
   */
  displayConfirmationViewCancel() {
    const enableFormControls = (...controlNames: string[]) => {
      controlNames.forEach(controlName => {
        this.globalUserDataForm.get(controlName).enable();
      });
    };

    this.displayModalApprove = false;
    enableFormControls('selectedDate', 'selectedWorkshop', 'selectedPackage', 'selectedAmount');

    let matReqLst = this.materialsTmp ?? this.materials ?? [{}];
    let matReqLstTotal = this.materialsTotal ?? [{}];

    this.materials = matReqLst;
    this.materialsTotal = matReqLstTotal;

  }

  /**
   * The function asynchronously approves inventory for a location material control, handling
   * success and error cases accordingly.
   */
  async aprove() {
    this.blocked = true;

    // let _locMatCtlH = this.globalUserDataForsaveUpdatePriceItemm.get('selectedLocmatctlh')?.value ?? null;
    let _locMatCtlM = this.globalUserDataForm.get('selectedLocmatctlm')?.value ?? null;
    let _docIdH = this.globalUserDataForm.get("selectedLocmatctlm").value?.form0?.year ?? this.dataParent.year ?? null;
    let _storeId = this.globalUserPreferences?.preferences?.coordinationId || null;
    let _language = this.globalUserPreferences?.preferences?.language || null;
    let _loginId = this.globalUserPreferences?.preferences?.userId || null;
    let arrayData = this.materials ?? [{}];
    let isValid = true;
    const _docType = this.dataParent.docType ?? "";

    try {

      // SE AÑADE VALIDACION CONTRA INVENTARIO
      const _lstGs = arrayData.map(item => ({
        id: item.itemId,
        itemCat: item.itm.itemCat3,
        field01: item?.matd?.reqQty?.toString() ?? 0,
        field16: _docType == 'S' ? (item?.matd?.reqQty ?? 0) <= (item?.onHand ?? 0) : true
      }));

      _lstGs.filter(e => e.itemCat !== '12' && e.itemCat !== '13').forEach((e) => {
        if (e.field16 == false) {
          this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_no} ${this.translations.lbl_inventory} ${this.translations.lbl_for} ${e.id}` });
          isValid = false;
        }
      });

      // SE RETIRA CASO DE APROBACIÓN
      if (this.dataParent.docType === 'S' && !isValid) {
        this.displayConfirmationViewCancel();
        this.reloadData();
        this.blocked = false;
        return;
      }


      this.displayConfirmationViewCancel();
      this.blocked = true;

      //ACTUALIZAMOS IMPORTE
      _locMatCtlM['totAmt'] = this.globalUserDataForm.get('selectedAmount').value ?? 0;

      const result = await this.apiService.crudLocMatCtl({
        locM: _locMatCtlM,
        locD: null,
        language: _language,
        method: "APPROVE",
      });
      this.blocked = false;
      if (result != null) {
        if (result.status === StatusType.ERROR) {
          this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: result.errorMessage });
          return;
        }
        let accbalanceRes = await this.apiService.createBalanceByDocument({
          "docId": _locMatCtlM.id.year + "," + _locMatCtlM.id.sequence,
          "menuOption": "CXC3",
          "userId": this.globalUserPreferences.login
        });
        if (accbalanceRes != null) {
          this.messageService.add({ severity: 'success', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: this.translations.lbl_approved });
          this.blocked = false;
          this.goBack();
        }
        else {
          this.blocked = false;
          console.error("An error occurred while fetching languages:", accbalanceRes);
          this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_approve} ${this.translations.inventory} ${this.translations.lbl_cancelled} ${this.translations.lbl_then_try_it_again} ` + accbalanceRes.errorMessage });
        }
      } else {
        this.blocked = false;
        console.error("An error occurred while fetching languages:", result);
        this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_approve} ${this.translations.inventory} ${this.translations.lbl_cancelled} ${this.translations.lbl_then_try_it_again} ` + result.errorMessage });
      }
    } catch (error) {
      console.error("An error occurred while fetching languages:", error);
      this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_approve} ${this.translations.inventory} ${this.translations.lbl_cancelled} ${this.translations.lbl_then_try_it_again} ` });
      this.blocked = false;
    }
    this.blocked = false;
  }

  /**
   * The function  in TypeScript asynchronously creates or updates data related to
   * packages and materials.
   */
  async createByPackages() {
    this.blocked = true;
    try {
      const selWorksId = this.globalUserDataForm.get('selectedWorkshop').value?.form0?.wrksId || this.dataParent.wrksId || null;
      const selStoreId = this.globalUserPreferences?.preferences?.coordinationId || null;
      const selGuideId = this.dataParent.guideId || null;
      const selLanguage = this.globalUserPreferences?.preferences?.language || null;
      const selListId = this.globalUserDataForm.get("selectedLocmatctlm").value?.listId ?? this.globalUserDataForm.get("selectedList").value ?? null;
      const selDocType = this.dataParent.docType || null;

      // Crea el locmatctlm y lo asigna al forms
      const res = await this.createAssignLocMatCtlm(selStoreId, selGuideId, selLanguage, selWorksId, selDocType, selListId);

      const message = res === false ? this.translations.lbl_internal_server_error : this.translations.lbl_updated_data;
      const severity = res === false ? 'warning' : 'success';
      this.messageService.add({ severity: severity, summary: this.translations.lbl_material_payment_registry_Loc, detail: message, life: 5000 });
      this.blocked = false;

      if (severity === 'success') {
        await this.updateMatItem();
        await this.updateLocMatCtlHM();
        this.blocked = false;
      } else {
        this.messageService.add({ severity: severity, summary: this.translations.lbl_material_payment_registry_Loc, detail: `${this.translations.lbl_unable} ${this.translations.lbl_to} ${this.translations.lbl_create}`, life: 5000 });
        this.blocked = false;
      }

    } catch (error) {
      console.error("Error en create by packages", error);
      this.blocked = false;
    }
    this.blocked = false;
  }

  async createAssignLocMatCtlm(storeId, guideId, language, worksId, docType, listId) {
    let responseM = this.globalUserDataForm.get('selectedLocmatctlm').value ?? null;
    let isStage = false;
    const stage = this.globalUserDataForm.get('selectedWorkshop').value?.form0.wrksId;
    try {
      if (stage === '16' || stage === '17' || stage === '18') {
        isStage = true;
      }

      if (responseM.id.year == null && responseM.id.sequence == null) {
        responseM = await this.apiService.createLocmatctlM({
          id: {
            sequence: null,
            year: null
          },
          storeId: storeId,
          guideId: guideId,
          language: language,
          wrksId: isStage ? null : worksId,
          currDate: this.tovUtilsService.dateToTovpilDate(new Date()),
          docType: docType,
          listId: listId,
          sellType: isStage ? (parseInt(this.globalUserDataForm.get('selectedWorkshop').value?.form0.wrksId) - 15).toString() : null
        });
      }

      this.globalUserDataForm.patchValue({
        selectedLocmatctlm: responseM
      });

      return true;

    } catch (error) {
      console.error("Error create LocMatCtlm(): ", error);
      return false;
    }
  }

  /**
   * The function checks for specific conditions in form data and loads data if
   * conditions are met.
   * @returns If the conditions in the function are met, the function will return
   * without executing statement.
   */
  async updateMatItem() {
    // SI PASAMOS PARAMETROS NO LOS BUSCA
    if (this.globalUserDataForm.get('selectedLocmatctlm').value == null) {
      this.globalUserDataForm.patchValue({
        selectedPackage: 0.0
      });
      this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_unable} ${this.translations.lbl_update} ${this.translations.lbl_item}` }); //sin locamatctlh creado
      return;
    }

    if (this.globalUserDataForm.get('selectedWorkshop').value == null &&
      this.globalUserDataForm.get('selectedPackage').value == null &&
      this.globalUserDataForm.get('selectedPackage').value >= 0) {
      this.messageService.add({ severity: 'warn', summary: `E/S  ${this.translations.lbl_materials} ${this.translations.lbl_detail}`, detail: `${this.translations.lbl_unable} ${this.translations.lbl_update} ${this.translations.lbl_item}` }); //sin un servicio seleccionado
      return;
    }
    await this.loadData();
  }

  /**
   * The function is intended to validate an empty order.
   */
  validateEmptyOrder() {
    let response = false;
    try {
      response = this.materials.every((itm) => (itm.price === 0) && (itm?.matd?.reqQty != null && itm?.matd?.reqQty === 0));
      return response;
    } catch (e) {
      console.error(e);
      return response;
    }
  }

  /**
   * The function `capitalizeFirstLetter` takes a string as input and returns the same string with the
   * first letter capitalized.
   * @param inputString - The `capitalizeFirstLetter` function takes a string as input and capitalizes
   * the first letter of the string. If the input string is not empty, it returns the string with the
   * first letter capitalized. If the input string is empty, it returns the input string as it is.
   * @returns The `capitalizeFirstLetter` function takes an input string and returns the same string
   * with the first letter capitalized. If the input string is empty, it returns the input string as
   * is.
   */
  capitalizeFirstLetter(inputString) {
    if (inputString.length > 0) {
      return inputString.charAt(0).toUpperCase() + inputString.slice(1);
    } else {
      return inputString;
    }
  }

  /** MANAGE PREFERENCES */

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    // console.debug("CX3 RCM - ON CHANGE USER PREFERENCES: ")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
    // this.getLanguages();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = (this.globalUserDataForm.get('selectedLanguage').value)?.valueId || null;
    let period = (this.globalUserDataForm.get('selectedPeriod').value) || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      period?.year || null, //_selYear
      period?.period || null, //_selPeriod
      null, //_device
      null, //_storeSelected
      period, //_periodSelected
      null //_stores
    );
  }

  getButtonConfig() {
    return {
      icon: this.isOnlyArticles === true ? 'pi pi-eye-slash' : 'pi pi-eye',
      label: this.isOnlyArticles === true
        ? `${this.translations.lbl_by} ${this.translations.lbl_only} ${this.translations.lbl_item}`
        : this.translations.lbl_package,
      tooltip: this.isOnlyArticles === true
        ? `${this.translations.lbl_is_going_to_apply} ${this.translations.lbl_rule} ${this.translations.lbl_of} ${this.translations.lbl_addition} ${this.translations.lbl_of} ${this.translations.lbl_items} ${this.translations.lbl_individual}`
        : `${this.translations.lbl_is_going_to_apply} ${this.translations.lbl_rule} ${this.translations.lbl_of} ${this.translations.lbl_addition} ${this.translations.lbl_of} ${this.translations.lbl_package} ${this.translations.lbl_and} ${this.translations.lbl_or} ${this.translations.lbl_items}`,
      styleClass: this.isOnlyArticles === true ? 'p-button-danger' : 'p-button-success'
    };
  }
}
